import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Link, Text, HStack } from '@chakra-ui/react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    // Check if path already has a language prefix
    const hasLanguagePrefix = /^\/[a-z]{2}(\/|$)/.test(path);
    if (hasLanguagePrefix) {
      return path; // Already localized, return as-is
    }
    
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  const handleNavigate = (href: string) => {
    navigate(getLocalizedPath(href));
  };

  return (
    <Box mb={6}>
      <HStack spacing={2} fontSize="sm" fontFamily="Source Code Pro">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {item.href ? (
              <Link 
                color="black" 
                _hover={{ textDecoration: 'underline' }}
                cursor="pointer"
                onClick={() => handleNavigate(item.href!)}
              >
                {item.label}
              </Link>
            ) : (
              <Text color="black">{item.label}</Text>
            )}
            {index < items.length - 1 && (
              <Text color="black">→</Text>
            )}
          </React.Fragment>
        ))}
      </HStack>
    </Box>
  );
};

export default Breadcrumb;